import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";

export const ratingTableSentence = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { before: 50, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    pageBreakBefore: true,
    children: [
        new TextRun({
            text: "The scale shown below has been used to rate the level of risk:",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})